import { RoundButton } from '@/components/UI/RoundButton';

export const ErrorBoundaryFallback = () => {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
      }}
    >
      <div
        style={{
          margin: 'auto',
          textAlign: 'center',
          display: 'flex',
          gap: '10px',
          flexDirection: 'column',
        }}
      >
        <h2 className="f-26-32">Ooops, something went wrong :( </h2>
        <div>
          <RoundButton
            label="Refresh"
            fillBackground
            onClick={() => window.location.assign(window.location.origin)}
          />
        </div>
      </div>
    </div>
  );
};
